module.exports = __webpack_public_path__ + "mfa_lock.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mfa_lock.png
// module id = 1874
// module chunks = 0